// extracted by mini-css-extract-plugin
module.exports = {"privacy":"privacy_policy_privacy__1Kh-x","inner":"privacy_policy_inner__2zPfl","blue":"privacy_policy_blue__26X0p"};